import React, { useMemo } from "react";
import { MimaButton, MimaTable } from "../../components";
import constant from "../../utils/constant";
import moment from "moment";
import { downloadXlsx2 } from "../../utils/download";

const MarketerTable = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  setItem,
  setTradingName,
  setTodoModal,
}) => {
  const marketerTableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.commissions || [];
    }
    return [];
  }, [data]);

  const marketerTableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },
    {
      Header: "Marketer Name",
      accessor: "marketer",
      Cell: ({ cell }) => {
        const firstname = cell.row.original?.marketer?.firstname;
        const lastname = cell.row.original?.marketer?.lastname;
        const marketer = `${firstname} ${lastname}`;
        return <span>{marketer}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "business",
      Cell: ({ cell }) => {
        const business = cell.row.original?.business?.tradingName;
        return <span>{business}</span>;
      },
    },
    {
      Header: "Commission Status",
      accessor: "commissionStatus",
    },
    {
      Header: "Subscription Status",
      accessor: "subscriptionStatus",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original.business.id;
        const tradingName = cell.row.original?.business?.tradingName;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setTradingName(tradingName);
              setItem(item);
              setTodoModal(true);
            }}
          >
            View Todo Info
          </span>
        );
      },
    },
  ];

  const printData = marketerTableData.map((item) => ({
    "Created Date": item?.createdAt,
    Marketer: `${item?.marketer?.firstname} ${item?.marketer?.lastname}` || "",
    "Business Name": item.business?.tradingName || "",
    "Commissions Status": item.commissionStatus || "",
    "Subscription Status": item.subscriptionStatus || "",
  }));

  return (
    <>
      <MimaButton
        title="Download Marketer Report"
        onClick={() => {
          downloadXlsx2(printData, "Marketer Report");
        }}
        mt={4}
      />

      <MimaTable
        tableData={marketerTableData}
        tableColumns={marketerTableColumns}
        searchPlaceholder="Search News"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
    </>
  );
};
export default MarketerTable;
